import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Worksheet } from './models/worksheet.model';

export interface WorksheetState extends EntityState<Worksheet> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'worksheet', idKey: 'WorksheetId' })
export class WorksheetStore extends EntityStore<WorksheetState> {

  constructor() {
    super();
  }
}